import { useEffect, useState } from "react"
import { PanelLoader } from "../../../../../features/ui"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { RoutePath } from "../../../../../features/routes"
import { CashFundList } from "./cashFundList"
import { CashFund } from "../../../state/types"
import { useCashFundLoaders } from "../../../loaders/cashFundLoaders"
import { ListLoaderWrapper } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"

const Loader = () => {
  const [cashFunds, setCashFunds] = useState<CashFund[]>([])
  const [ready, setReady] = useState(false)

  const cashFundLoaders = useCashFundLoaders()

  const populate = async () => {
    const { loadAllCashFunds } = cashFundLoaders()
    setCashFunds(await loadAllCashFunds(true))
  }

  useEffect(() => {
    populate().then(() => setReady(true))
  }, [])

  return (
    <PanelLoader
      title="Cajas"
      ready={ready}
      wide
      titleRight={<BookmarkButton routePath={RoutePath.CASH_FUNDS} />}
    >
      <CashFundList cashFunds={cashFunds}/>
    </PanelLoader>
  )
}

export const CashFundListLoader = () => (
  <ListLoaderWrapper table={TableName.CASH_FUNDS}>
    <Loader />
  </ListLoaderWrapper>
)
